module.exports = __webpack_public_path__ + "media/img/pages/profile/hslu ger 5-c9763fe2549415b923e6250c2e23f931.jpg";